<sui-button
  class="facebook-login"
  variant="secondary"
  size="lg"
  type="button"
  [leadingIcon]="['fab', 'facebook']"
  (click)="auth()"
>
  <span>{{ "facebook-auth.button.sign-up-with-facebook" | translate }}</span>
  <fa-icon
    [icon]="['fas', 'info-circle']"
    [ngpPopoverTrigger]="helpPopover"
    (click)="$event.stopPropagation()"
    [ngpPopoverTriggerContainer]="'body'"
    [ngpPopoverTriggerPlacement]="'top'"
  >
  </fa-icon>

  <ng-template #helpPopover>
    <div ngpPopover class="facebook-info">
      You can log in into Sensika by using your Facebook account. If you choose
      to continue with the Facebook login, Sensika will request basic
      permissions to access your public Facebook profile and E-mail. You will
      then be asked to approve Sensika's Facebook App and after the successful
      approval, you will be able to link your Facebook account with your Sensika
      account, by entering your Sensika credentials (username/E-mail and your
      Sensika password). After your accounts are linked you will be able to sign
      in to Sensika with a single click.
    </div>
  </ng-template>
</sui-button>
